import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Location } from '@angular/common';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
  title = 'trans-app';
  disableMenu : boolean = true;

  constructor(location: Location, router: Router) {
    router.events.subscribe((val) => {
      this.disableMenu = location.path() != '';
    });
  }

  ngOnInit() {
    
  }
}
